<template>
  <section class="customerOwnedAwsAccounts">
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <material-card
            color="orange"
            title="Register Customer Owned Accounts">
            <v-container fluid class="request-details">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>

                  <!-- Phase 1: Basic Account Information -->
                  <v-container class="form-section">
                    <div class="phase-title"> </div>

                    <!-- Opportunity ID -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Opportunity ID (OPP ID)</label>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.opportunityId"
                          placeholder="Enter Opportunity ID"
                          name="opportunityId"
                          solo
                          outlined
                          :error="!!formErrors.opportunityId"
                          :error-messages="formErrors.opportunityId ? [formErrors.opportunityId] : []"
                          @input="updateFormField('opportunityId', $event)"
                          @keyup.enter="onOppIdValidate"
                        >
                          <template v-slot:append>
                            <v-btn
                              class="my-0"
                              small
                              :loading="isValidatingOppId"
                              @click="onOppIdValidate"
                              :disabled="!form.opportunityId || isValidatingOppId"
                            >
                              <span v-if="!isValidatingOppId && disableContinue">validate</span>
                              <v-icon
                                v-else-if="!isValidatingOppId"
                                small>check</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Customer Name -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Customer Name</label>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.customerName"
                          placeholder="Enter customer name"
                          solo
                          outlined
                          name="customerName"
                          :disabled="isFormLocked"
                          :error="!!formErrors.customerName"
                          :error-messages="formErrors.customerName ? [formErrors.customerName] : []"
                          @input="updateFormField('customerName', $event)"
                        />
                      </v-flex>
                    </v-layout>

                    <!-- AWS Account IDs -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Client owned AWS Account ID(s)</label>
                      </v-flex>
                      <!-- <v-flex flex align-center md4 pt-2 pl-4 pr-2 class="align-center"> -->
                      <v-flex md4 pr-2 >
                        <label>AWS Account ID</label>
                        <v-text-field
                          v-model="form.accountId"
                          label=""
                          placeholder="Enter AWS Account ID"
                          solo
                          name="accountId"
                          :disabled="isFormLocked"
                          :error="!!formErrors.awsAccountIds"
                          :error-messages="formErrors.awsAccountIds ? [formErrors.awsAccountIds] : []"
                        />
                      </v-flex>
                      <!-- <v-flex
                        md6
                        pt-2
                        pr-4
                        class="align-center">
                        <label>Region(s)</label>
                        <v-autocomplete
                          v-model.lazy="form.regions"
                          :items="regions"
                          item-text="label"
                          item-value="value"
                          persistent-hint
                          open-on-clear
                          attach
                          multiple
                          chips
                          small-chips
                          solo
                          placeholder="Select region(s)"
                          name="regions"
                          :disabled="isFormLocked"
                          :error="!!formErrors.awsAccountIds"
                          :error-messages="formErrors.awsAccountIds ? [] : []"
                        />
                      </v-flex> -->
                      <v-flex md2 pt-2 pr-4 class="d-flex align-center">
                        <v-btn class="opp-btn" color="warning" :disabled="isFormLocked" @click="add">Add Account ID</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center"/>
                      <v-flex md6>
                        <p class="txt-template">
                          For multiple AWS Account IDs, you can upload a CSV file instead. Download the template <a href="#" @click.prevent="downloadTemplate">here</a> to get started.
                        </p>
                        <div class="upload-row">
                          <input
                            ref="csvUpload"
                            type="file"
                            accept=".csv"
                            @change="handleCsvUpload"
                            style="display: none"
                          />
                          <v-btn
                            class="opp-btn"
                            color="success"
                            :loading="uploadingCsv"
                            :disabled="isFormLocked"
                            @click="triggerCsvUpload"
                          >
                            Upload CSV
                          </v-btn>
                          <span class="upload-error" v-if="uploadError">{{ uploadError }}</span>
                        </div>
                      </v-flex>
                    </v-layout>

                    <!-- <v-layout row align-center class="form-row" v-if="listAccounts.length > 0"> -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 pb-4 class="d-flex align-center"/>
                      <v-flex md6>
                        <v-data-table
                          :headers="accountListHeaders"
                          :items="listAccounts"
                          :items-per-page="2"
                          class="elevation-1"
                        >
                          <template v-slot:items="props">
                            <td class="">
                              <v-icon small class="mr-2" :disabled="isFormLocked" @click="editItem(props.item)">edit</v-icon>
                              <v-icon small :disabled="isFormLocked" @click="deleteItem(props.item)">delete</v-icon>
                            </td>
                            <td>{{ props.item.accountId }}</td>
                            <!-- <td>{{ props.item.regions.toString() }}</td> -->
                          </template>
                        </v-data-table>
                        <v-dialog v-model="dialog" max-width="700px">
                          <v-card>
                            <v-card-text>
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex xs12 sm12 md12 xl12>
                                    <label>Client owned AWS Account ID</label>
                                    <v-text-field
                                      v-model="editedItem.accountId"
                                      label="AWS Accounts"
                                      placeholder="AWS Accounts"
                                      solo
                                    />
                                  </v-flex>
                                  <!-- <v-flex xs12 sm12 md12 xl12>
                                    <label>Region(s)</label>
                                    <v-autocomplete
                                      v-model.lazy="editedItem.regions"
                                      :items="regions"
                                      item-text="label"
                                      item-value="value"
                                      persistent-hint
                                      open-on-clear
                                      attach
                                      multiple
                                      chips
                                      small-chips
                                      solo
                                    />
                                  </v-flex> -->
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn @click="close">Cancel</v-btn>
                              <v-btn class="opp-btn" color="warning" @click="save">Save</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>

                    <!-- Supporting PDL -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Supporting PDL</label>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.supportingPdl"
                          placeholder="Enter supporting PDL email"
                          solo
                          outlined
                          name="supportingPdl"
                          :disabled="isFormLocked"
                          :error="!!formErrors.supportingPdl"
                          :error-messages="formErrors.supportingPdl ? [formErrors.supportingPdl] : []"
                          @input="updateFormField('supportingPdl', $event)"
                        />
                      </v-flex>
                    </v-layout>

                    <!-- Account Contact -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Account Contact (Technical or Financial)</label>
                      </v-flex>
                    <!-- </v-layout>
                    <v-layout row align-center class="form-row"> -->
                      <v-flex md4 pt-2 pr-4>
                        <v-text-field
                          v-model="form.contactEmail"
                          placeholder="Enter account contact email"
                          solo
                          outlined
                          name="contactEmail"
                          :disabled="isFormLocked"
                          :error="!!formErrors.contactEmail"
                          :error-messages="formErrors.contactEmail ? [formErrors.contactEmail] : []"
                          @input="updateFormField('contactEmail', $event)"
                        />
                      </v-flex>
                      <v-flex md4 pt-2 pr-4>
                        <v-text-field
                          v-model="form.contactName"
                          placeholder="Enter account contact name"
                          solo
                          outlined
                          name="contactName"
                          :disabled="isFormLocked"
                          :error="!!formErrors.contactName"
                          :error-messages="formErrors.contactName ? [formErrors.contactName] : []"
                          @input="updateFormField('contactName', $event)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <!-- Request Managed Services Toggle -->
                  <v-container class="toggle-section">
                    <v-layout row align-center>
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label>Request Managed Services?</label>
                      </v-flex>
                      <v-flex md6>
                        <v-switch
                          v-model="form.requestManagedServices"
                          color="primary"
                          name="requestManagedServices"
                          :disabled="isFormLocked"
                          @change="updateFormField('requestManagedServices', $event)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <!-- Phase 2: Optional Managed Services (Conditional) -->
                  <v-container v-if="form.requestManagedServices" class="form-section managed-services-sections">
                    <div class="phase-title"> </div>
                    
                    <!-- WBS Code -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">WBS Code</label>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.wbsCode"
                          placeholder="Enter WBS Code"
                          solo
                          outlined
                          name="wbsCode"
                          :disabled="isFormLocked"
                          :error="!!formErrors.wbsCode"
                          :error-messages="formErrors.wbsCode ? [formErrors.wbsCode] : []"
                          @input="updateFormField('wbsCode', $event)"
                        />
                      </v-flex>
                    </v-layout>

                    <!-- Target Deployment Date -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label class="required">Target Deployment Completion Date</label>
                      </v-flex>
                      <v-flex md6>
                        <v-date-picker
                          v-model="form.targetDeploymentDate"
                          name="targetDeploymentDate"
                          :allowed-dates="allowedDates"
                          :disabled="isFormLocked"
                          @input="updateFormField('targetDeploymentDate', $event)"
                        />
                      </v-flex>
                    </v-layout>

                    <!-- Customization Description (Optional) -->
                    <v-layout row align-center class="form-row">
                      <v-flex md4 pt-2 class="d-flex align-center">
                        <label>Customization Description</label>
                      </v-flex>
                      <v-flex md6>
                        <v-textarea
                          v-model="form.customizationDescription"
                          placeholder="Describe any customization per the SOW that deviates from standard Gold Managed Services"
                          solo
                          outlined
                          rows="3"
                          name="customizationDescription"
                          :disabled="isFormLocked"
                          @input="updateFormField('customizationDescription', $event)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <!-- Error and Success Messages -->
                  <v-container v-if="submitError" class="error-message">
                    <v-alert type="error" dismissible>
                      {{ submitError }}
                    </v-alert>
                  </v-container>

                  <v-container v-if="submitSuccess" class="success-message">
                    <v-alert type="success" dismissible>
                      Account registered successfully! 
                      <span v-if="!form.requestManagedServices">Your account has been saved to the Galaxy inventory.</span>
                      <span v-else>Your managed services request has been submitted and will be processed shortly.</span>
                    </v-alert>
                  </v-container>

                  <!-- Action Buttons -->
                  <v-container class="button-section">
                    <v-layout row justify-end>
                      <v-flex xs12 sm6 md2 class="button-row">
                        <v-btn
                          color="primary"
                          :loading="isSubmitting"
                          :disabled="isSubmitting || isFormLocked"
                          @click="submitForm"
                          class="full-width"
                        >
                          {{ form.requestManagedServices ? 'Submit Request' : 'Register Account' }}
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm6 md2 class="button-row">
                        <v-btn
                          outlined
                          color="secondary"
                          :disabled="isSubmitting"
                          @click="resetFormData"
                          class="full-width"
                        >
                          Clear Form
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Papa from 'papaparse'

export default {
  name: 'CustomerOwnedAwsAccounts',
  data () {
    return {
      listAccounts: [],
      editedItem: {
        aws_account_id: ''
      },
      editedIndex: -1,
      dialog: false,
      isDownloadingTemplate: false,
      uploadingCsv: false,
      uploadError: null
    }
  },
  computed: {
    ...mapState('user/registerCustomerOwnedAccts', [
      'form',
      'formErrors',
      'isSubmitting',
      'submitError',
      'submitSuccess',
      // 'regions',
      'accountListHeaders',
      'isValidatingOppId',
      'oppIdValidated',
      'oppIdData'
    ]),
    isFormLocked () {
      return !this.form.opportunityId || !this.oppIdValidated || this.isValidatingOppId
    },
    disableContinue () {
      return this.isFormLocked
    }
  },
  mounted () {
    this.$store.commit('user/registerCustomerOwnedAccts/resetForm')
  },
  methods: {
    updateFormField (field, value) {
      this.$store.commit('user/registerCustomerOwnedAccts/setFormField', { field, value })
    },
    resetFormData () {
      this.$store.commit('user/registerCustomerOwnedAccts/resetForm')
      this.listAccounts = []
    },
    async submitForm () {
      console.log('Submitting form with data:', this.form)
      // this.form.awsAccountIds = this.listAccounts.length > 0 ? JSON.stringify(this.listAccounts) : ''
      this.form.awsAccountIds = this.listAccounts.length > 0 ? this.listAccounts : ''
      await this.$store.commit('user/registerCustomerOwnedAccts/clearFormErrors')
      await this.$store.dispatch('user/registerCustomerOwnedAccts/submitForm', this.form)
      if (this.submitSuccess) {
        this.$store.commit('user/registerCustomerOwnedAccts/resetForm')
        this.$store.commit('user/registerCustomerOwnedAccts/clearFormErrors')
        this.listAccounts = []
      }
    },
    allowedDates (val) {
      // Only allow future dates
      const today = new Date()
      const selectedDate = new Date(val)
      return selectedDate >= today
    },
    add () {
      console.log('Adding new account:', this.form.accountId)
      let newList = {
        accountId: this.form.accountId
        // regions: this.form.regions
      }
      const dataExist = this.listAccounts.some(item => item.accountId === newList.accountId)
      if (dataExist) {
        alert('Account ID already exists')
      } else {
        console.log('add list')
        this.listAccounts.push(newList)
        console.log('Updated list:', this.listAccounts)
        this.form.accountId = ''
        // this.form.regions = ''
      }
    },
    editItem (item) {
      this.editedIndex = this.listAccounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.listAccounts.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.listAccounts.splice(index, 1)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, { aws_account_id: '' })
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        console.log('save', this.editedIndex)
        Object.assign(this.listAccounts[this.editedIndex], this.editedItem)
      } else {
        console.log('else save', this.editedIndex)
        this.listAccounts.push(this.editedItem)
      }
      this.close()
    },
    async downloadTemplate () {
      this.isDownloadingTemplate = true
      this.$store.dispatch('user/registerCustomerOwnedAccts/downloadTemplate')
      this.isDownloadingTemplate = false
    },
    triggerCsvUpload () {
      this.uploadError = null
      this.$refs.csvUpload.click()
    },
    async handleCsvUpload (event) {
      this.uploadError = null
      this.uploadingCsv = true
      const file = event.target.files[0]
      if (!file) {
        this.uploadingCsv = false
        return
      }
      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.uploadError = 'Please upload a CSV file.'
        this.uploadingCsv = false
        return
      }
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          console.log('CSV parse results:', results)
          const parseErrors = (results.errors || []).filter(error => error.code !== 'UndetectableDelimiter')
          if (parseErrors.length) {
            this.uploadError = `CSV parse error: ${parseErrors[0].message}`
            this.uploadingCsv = false
            return
          }
          const parsed = results.data.map(row => (console.log('row:', row), {
            accountId: (row['AWS Account ID'] || row['accountId'] || row['AccountId'] || row['AWSAccountID'] || '').trim()
          }))
          console.log('parsed:', parsed)
          const validRows = parsed.filter(row => row.accountId)
          if (!validRows.length) {
            this.uploadError = 'No valid AWS Account ID rows found in CSV.'
            this.uploadingCsv = false
            return
          }
          const duplicateIds = []
          validRows.forEach(row => {
            if (this.listAccounts.some(item => item.accountId === row.accountId)) {
              duplicateIds.push(row.accountId)
            } else {
              this.listAccounts.push(row)
            }
          })
          if (duplicateIds.length) {
            this.uploadError = `Skipped duplicate account IDs: ${duplicateIds.join(', ')}`
          }
          this.uploadingCsv = false
          this.$refs.csvUpload.value = null
        },
        error: (error) => {
          this.uploadError = `Failed to parse CSV: ${error.message}`
          this.uploadingCsv = false
          this.$refs.csvUpload.value = null
        }
      })
    },
    getFilenameFromDisposition (contentDisposition) {
      const filenameRegex = /filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i
      const matches = filenameRegex.exec(contentDisposition)
      if (!matches) return null
      return decodeURIComponent(matches[1] || matches[2])
    },
    async onOppIdValidate () {
      var self = this
      console.log('validating opp id: ', self)
      console.log('validating opp id: ', self.form.opportunityId)
      await this.$store.dispatch('user/registerCustomerOwnedAccts/validateOppId', this.form.opportunityId)
      
    }
  }
}
</script>

<style scoped lang="scss">
.customerOwnedAwsAccounts {
  padding: 20px 0;

  .header {
    margin-bottom: 20px;

    h3 {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }

  .request-details {
    background: #f5f5f5;
    padding: 0;
  }

  .section-header {
    background: #f9f9f9;
    padding: 15px 20px;
    border-left: 4px solid #41B3DF;
    margin-bottom: 20px;

    .section-header-title {
      h4 {
        margin: 0;
        color: #333;
        font-weight: 600;
      }
    }
  }

  .form-section {
    background: white;
    padding: 20px;
    margin-bottom: 5px;
    border-radius: 4px;

    .phase-title {
      font-size: 16px;
      font-weight: 600;
      color: #41B3DF;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e0e0;
    }
  }

  .managed-services-section {
    border-left: 4px solid #FFA726;
  }

  .toggle-section {
    background: white;
    padding: 20px;
    margin-bottom: 5px;
    border-radius: 4px;
  }

  .form-row {
    margin-bottom: 20px;

    label {
      font-size: 14px;
      color: #555;
      font-weight: 500;

      &.required::after {
        content: ' *';
        color: #f44336;
      }
    }
  }

  .error-message,
  .success-message {
    margin-bottom: 20px;
  }

  .button-section {
    background: white;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .button-row {
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }
    }

    .full-width {
      width: 100%;
    }
  }
  .upload-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
  }

  .upload-error {
    color: #d32f2f;
    font-size: 13px;
  }
  .txt-template {
    font-size: 14px;
    color: #555;
    font-weight: 500;
  }
}
</style>
